import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/data.service';
import { MatDialog } from '@angular/material/dialog';
import { EditRoadBlockComponent } from 'app/components/edit-road-block/edit-road-block.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';
import { ConfirmationBoxComponent } from 'app/components/confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-manage-road-blocks',
  templateUrl: './manage-road-blocks.component.html',
  styleUrls: ['./manage-road-blocks.component.css']
})
export class ManageRoadBlocksComponent implements OnInit {

  advertisements = []

  constructor(private adminService: DataService, private dialog: MatDialog, private notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.adminService.getRoadBlockAd().subscribe(data => {
      if(data.status){
        let advertisements = data.roadBlocks
        if(advertisements.length){
          for(let ad of advertisements){
            ad['imagePath'] = environment.api + '/images/' + ad['imagePath']
            this.advertisements.push(ad)
          }
        }
      }
    })
  }

  addRoadBlock(){
    const dialogRef = this.dialog.open(EditRoadBlockComponent, {
      width: '600px',
      height: 'auto',
      data: {
        link: '',
        image: null,
        imagePath: '',
        status: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.adminService.addRoadBlock(result).subscribe(data => {
          if(data.status){
            this.openNotification(data.message)
            data.roadBlockAd.imagePath = environment.api + '/images/' + data.roadBlockAd.imagePath
            this.advertisements.push(data.roadBlockAd)
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  updateRoadBlock(ad){
    const dialogRef = this.dialog.open(EditRoadBlockComponent, {
      width: '600px',
      height: 'auto',
      data: {
        link: ad.link,
        image: null,
        imagePath: ad.imagePath,
        status: ad.status
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result)
        this.adminService.editRoadBlock(ad.id, result).subscribe(data => {
          if(data.status){
            this.openNotification(data.message)
            data.roadBlock.imagePath = environment.api + '/images/' + data.roadBlock.imagePath
            this.advertisements[this.advertisements.indexOf(ad)] = data.roadBlock
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  openNotification(msg){
    this.notification.open(msg , 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  deleteRoadBlockAd(ad){
    let dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        text: 'Are you sure you want to delete this item?'
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.adminService.deleteRoadBlock(ad.id).subscribe(data => {
          if(data.status){
            let index = this.advertisements.indexOf(ad)
            this.advertisements.splice(index, 1)
            this.openNotification('Road Block has been deleted!')
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

}
